/* shioulo
    外部開發人員專用, 以減少同時修改所產生的更新困擾

    ⚠ 這支的用意是「Budget 模組的元件註冊集中在這裡」，不要跟 main.js 的
      componentRegistry 混著放 —— 分兩邊會出現「加了元件卻掛不上」而且很難找。
      main.js 會在 componentRegistry 建好之後呼叫 setCompoment() 把這裡的合併進去。
*/
export function setCompoment(app) {
    // ── 預算編制模組（PCECUI demo 移植，純 UI 階段）──
    app['budget-list'] = () => import('./Budget/BudgetList.vue');
    app['budget-basic'] = () => import('./Budget/BudgetBasic.vue');
    app['budget-add'] = () => import('./Budget/BudgetAdd.vue');
    // 分標／併標共用同一支元件，用 data-vue-props 的 mode 區分
    app['budget-add-project'] = () => import('./Budget/BudgetAddProject.vue');
    app['budget-project-select'] = () => import('./Budget/BudgetProjectSelect.vue');
    app['budget-sub-item-choose'] = () => import('./Budget/BudgetSubItemChoose.vue');
    app['budget-edit'] = () => import('./Budget/BudgetEdit.vue');
}
